export const SEO_FAQ = [
  {
    question:
      "Where can I buy bakery machines, ovens, mixers and slicers in India?",
    answer:
      "Rahul Engineering Works (REW) manufactures and supplies industrial bakery machines in Kanpur, Uttar Pradesh — including rotary rack ovens, tunnel ovens, spiral mixers, bread slicers, rusk production lines and complete bakery plant equipment. Contact us at Udyog Kunj, Panki for quotes and factory visits.",
  },
  {
    question: "Does Rahul Engineering Works Kanpur manufacture bakery ovens?",
    answer:
      "Yes. We build rotary rack ovens, swing tray ovens, chain-type tunnel ovens and wire mesh tunnel ovens for bread, rusk, biscuit and large-scale commercial baking across India.",
  },
  {
    question: "Do you supply industrial mixers for bakery production?",
    answer:
      "Yes. REW manufactures slow speed mixers, spiral mixers, high speed mixers and planetary mixers for dough, batter and continuous bakery batching lines.",
  },
  {
    question: "Do you manufacture bread and rusk slicers?",
    answer:
      "Yes. We offer slow speed and high speed bread slicers designed for uniform slicing in commercial bakeries, sandwich bread lines and rusk manufacturing plants.",
  },
  {
    question:
      "Is Rahul Engineering Works a bakery machine manufacturer in Kanpur?",
    answer:
      "Rahul Engineering Works is a bakery equipment manufacturing company based in Kanpur since 1992, serving 750+ clients and 1000+ installations pan-India with bread, rusk and biscuit machinery.",
  },
  {
    question: "What bakery products can your machines make?",
    answer:
      "Our machines support bread, rusk, biscuits, buns, cakes and related bakery items through ovens, mixers, slicers, conveyors, moulds, trays and automated production lines.",
  },
];
